import React, { useState, useContext, useEffect } from 'react'
import { StateContext } from '../../Util/StateContext/StateContext';
import RequestCartTable from './RequestCartTable/RequestCartTable';
import RequestCartForm from './RequestCartForm/RequestCartForm';
import blue_filter_svg from '../../assets/blue-icon-filter.svg';

const RequestCart = ({ setShowFilters, showFilters }) => {
    const { state, dispatch } = useContext(StateContext);
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        if (state.requests.length > 0) {
            setDrawerOpen(true);
        } else {
            setDrawerOpen(false);
        }
    }, [state.requests])

    const requestCartColumns = React.useMemo(
        () => [
            {
                Header: 'Root Part Number',
                accessor: "root_part_numbers",
                // maxWidth: 400,
                textAlign: "left"
            },
            {
                Header: 'Nomenclature',
                accessor: 'nomenclature',
                // maxWidth: 400,
                textAlign: "left"
            },
            {
                Header: 'Engine Oem',
                accessor: 'engine_oem',
                // maxWidth: 400,
                textAlign: "left"
            },
            {
                Header: 'Engine Applicability',
                accessor: 'engine_applicability',
                // maxWidth: 400,
                textAlign: "left"
            },

            {
                Header: 'QTY',
                accessor: 'qty',
                // maxWidth: 400,
                textAlign: "center"
            },
        ],
        []
    );

    const requestCartData = React.useMemo(() => {
        return state.requests;
    }, [state.requests]);

    return (
        <div id='tooling-cart'>
            <div className="inner-wrapper">
                <div className="wrapper">
                    <button
                        id="mobile-filter-toggle"
                        className={showFilters ? "filter-toggle is-open" : "filter-toggle"}
                        onClick={() => setShowFilters(!showFilters)}
                        aria-label={"Toggle Filter Drawer"}
                    >
                        <img alt="Arrow toggle for filter" src={blue_filter_svg} />
                        <p>Filters/Search</p>
                    </button>
                    <div className="toggle-section">
                        <h3 onClick={() => setDrawerOpen(!drawerOpen)}>{!drawerOpen ? "View" : "Hide"} Request Details <span>{!drawerOpen ? "+" : "-"} </span></h3>
                        <div className="submit-wrapper">
                            <p className="number-of-items">{`${state.requests.length} Item${state.requests.length === 1 ? "" : "s"}`}</p>
                            <button onClick={() => dispatch({ type: 'TOGGLE_FORM_DRAWER', payload: !state.formDrawerOpen })} className={"submit-button"}
                            >{!state.formDrawerOpen ? "Submit Request" : "Close Form"}</button>
                        </div>
                    </div>
                </div>
                <div className={drawerOpen ? "cart-drawer open" : "cart-drawer"}>
                    <h3 className="cart-drawer-header">Current Request</h3>
                    <div className="cart-drawer-body">
                        <RequestCartTable columns={requestCartColumns} data={requestCartData} />
                    </div>
                </div>
                <RequestCartForm
                    requests={state.requests}
                />
            </div>
        </div>
    )

}

export default RequestCart;